import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { FaCaretLeft } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa";
import Header from "../Header.js";
import api from "../../api/axios.js";

const QuizIntro = () => {
    const navigate = useNavigate();
    const {id} = useParams();
    const [quiz, setQuiz] = useState(null);

useEffect(() => {
  api.get("/api/quizzes/" + id)
    .then((res) => {
      console.log("SUCCESS:", res.data);
      setQuiz(res.data);
    })
    .catch((err) => {
      console.log("ERROR:", err);
    });
}, [id]);
    if(!quiz) return <p>Loading...</p>

       return (
        <>
           <div className="dashboard-wrapper">
            <Header />
           <div onClick={() => navigate(-1)} style={{ cursor: "pointer" }} className="nav_title">
              <FaChevronLeft className="fa-chevron-left"/>
              Your quizzes
           </div>
            
            <div className="quiz_introduction">
              <div className="quiz_intro_introduction">
                <p className="quiz_intro1">Introduction</p>
                <p className="quiz_intro2">Before you begin, here's what to expect:</p>
                <p className="quiz_intro3">Pass Score: 7/10:</p>
              </div>

              <div className="quiz_intro_rule">
                <ul style={{ listStyleType: "disc" }}>
                  <li>This quiz will test your understanding of the lesson.</li>
                  <li>Read each question carefully before selecting an answer.</li>
                  <li>You can skip questions and return to them later.</li>
                  <li>You have 30 minutes for 10 questions.</li>
                  <li>Your progress will be saved as you go.</li>
                </ul>
              </div>

              <div className="quiz_intro_explanation">
                <p>At the end of the quiz, you'll receive:</p>
                <ul>
                  <li>Your score</li>
                  <li>Correct answers</li>
                </ul>
                <p>If you fail, you have to review the lessons before retaking the test after 24 hours. Therefore, take your time and do your best.</p>
              </div>

                <div className="btn-wrapper">
                  <button onClick={() => navigate("/quiz/" + id)}>Start Quiz</button>
                </div>
            </div>
            </div>
        </>
    );
}

export default QuizIntro;